import React from 'react';
import visa from 'assets/images/visa.png';
import mastercard from 'assets/images/mastercard.png';
import jcb from 'assets/images/jcb.png';
import unionpay from 'assets/images/union-pay.png';
import americanexpress from 'assets/images/americanexpress.png';
import dbd from 'assets/images/dbd.png';
import kerry from 'assets/images/kerry.png';
import dhl from 'assets/images/dhl.png';
import yusen from 'assets/images/yusen.png';
import { Link  } from "react-router-dom";
import { } from 'utils/constants';
import {translate,gotoUrl, resolveRouterPath, getUpdatedPageUrl} from 'utils/common';
import {setCookie, getCookie} from 'utils/cookie';  

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.moveToTop = this.moveToTop.bind(this);
        this.monitorPageScroll = this.monitorPageScroll.bind(this);
        this.state = {showBtnTop:'none'};
        app.events.subscribe({'scroll':this.monitorPageScroll},this,-1);
    }
    componentDidMount() {
        console.log('-----footer mouted------');
    }
    componentDidUpdate() {
        //console.log('-----footer updated------');
    }  
    monitorPageScroll(){
        let showBtn = (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20)?'block':'none';
        this.setState({showBtnTop:showBtn});
    }
    moveToTop(){
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
    render(){
        //console.log('-----footer------');
        if(this.props.signedIn) return <div/>
        return(
            <React.Fragment>
                <footer className="footer fixed-bottom"> 
                    
                    <div className="rights"><div className="container-fluid"><div className="pad d-flex justify-content-between align-items-center">
                        <span className="rights-text">{translate('copyright')} &copy; {translate('copyright_text2')}</span>
                        <span className="address">{translate('footer_address')}</span>
                    </div></div></div>
                    
                </footer>
        
                 
            </React.Fragment>
        );
    }    
}

  export default Footer;